export default {
	field: 'catClass',
	name: 'CAT/CLASS #',
	width: '150px',
}
